import { render, staticRenderFns } from "./AmenityForm.vue?vue&type=template&id=d56141e8"
import script from "./AmenityForm.vue?vue&type=script&lang=js"
export * from "./AmenityForm.vue?vue&type=script&lang=js"
import style0 from "./AmenityForm.vue?vue&type=style&index=0&id=d56141e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports